@if (_active) {
  <kendo-window (close)="_closeForm()" (stateChange)="_onStateChanges($event)" [(state)]="windowState" [class.fullHeight]="maximized">
    <report-viewer [reportId]="reportId" [selectedReportFields]="selectedReportFields"
      [showFilter]="showFilter"
      [showEmail]="showEmail"
      [siteId] ="siteId"
      [transactionId]="transactionId" [windowMode]="windowMode" (closeForm)="_closeForm()" (maximizeWindow)="maximizeWindow()">
    </report-viewer>
  </kendo-window>
}
